import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Virtual Try-on";

const callVirtualTryOn = async (
	base64Ref: string,
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$pose_img: imageBase64,
					$ref_img: base64Ref,
				},
				tool_document_id,
				jwt,
			};
			return fetchVirtualTryOn(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchVirtualTryOn(
	params: {
		tool_document_id: string;
		inputs: {
			$pose_img: string;
			$ref_img: string;
		};
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenVirtualTryOnMessage() {
	useListenFromRenderer([
		{
			key: "virtualTryOn",
			onMessage: async (message) => {
				const success = await callVirtualTryOn(
					message.values.base64Ref,
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
